//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import screen from "apis/screen/screen";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";


// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function Create(props) {
  const { state, dispatch } = useContext(Context);

  const { createScreen } = screen();
  const history = useHistory();
  const classes = styles();
  const location = useLocation();
  
  const [states, setstates] = useState({
    screenName: "",
    screenPath: "",
    module:"",
    isActive: true,
    loading: false,
    roles: []
  });

  const {
    screenName,
    screenPath,
    module,
    isActive,
    loading,
    roles
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      handleGetRoles();
    }
  }, [location?.state?.data])

  function handleGetRoles() {
    setStates({
      ...states,
      roles: location?.state?.data?.map(i => {
        return { role_id: i.role_id, role_name: i.role_name, value: false }
      })
    });
  }

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "SCREEN", "CREATE"],
    });
  }, []);

  // create api func
  const handleCreateScreen = async () => {
    try {
      if (
        !screenName ||
        !screenPath
      ) {
        toast.error("Please fill all the fields", {
          toastId: "required-fields-error",
        });
        setStates({ loading: false });
        return;
      }
      const addedRoles = roles?.filter(i => i.value == true);
      let values;
      values = {
        screenName,
        screenPath,
        isActive,
        module
      };
      if (addedRoles.length > 0) {
        values = { ...values, screenMapping: addedRoles }
      }
      let res = await createScreen(values);
      if (res && res?.type === "SUCCESS") {
        toast.success("Created", { toastId: "rule-created" });
        history.goBack();
      }
      if (res && res?.type === "ERROR") {
        toast.error("Screen Already Exists", {
          toastId: "screen-exists",
        });
      }
      setStates({ loading: false });
    }
    catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          <span style={{ fontSize: 18, fontWeight: "bold" }}>{'Create'}</span>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ padding: 10 }}>
        <Grid item xs={3}>
          <CssTextField
            label={"Screen Name"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={screenName}
            onChange={(e) => {
              setStates({ screenName: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            label={"Screen Path"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={screenPath}
            onChange={(e) => {
              setStates({ screenPath: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            label={"Module Name"}
            fullWidth
            type={"text"}
            required
            className={classes.cssTextField}
            value={module}
            onChange={(e) => {
              setStates({ module: e.target.value });
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <CssTextField
            id={"Is Active"}
            label={"Is Active"}
            select
            fullWidth
            type={"text"}
            required
            value={isActive}
            onChange={(e) => {
              setStates({ isActive: e.target.value });
            }}
          >
            {[
              { label: "True", value: true },
              { label: "False", value: false },
            ].map((t, i) => (
              <MenuItem value={t.value} key={i}>
                {t.label}
              </MenuItem>
            ))}
          </CssTextField>
        </Grid>
      </Grid>
      <br />
      <Grid container spacing={1} item xs={12}>
        <Grid item xs={4}>
          <FormGroup>{
            roles?.slice(0, 4)?.map(i => {
              return <FormControlLabel
                key={i?.role_id}
                control={
                  <Checkbox
                    color="primary"
                    checked={i?.value}
                    onChange={(e) => {
                      let arr = [...roles];
                      let index = arr.findIndex(k => k.role_id == i.role_id);
                      if (e.target.checked) {
                        arr[index].value = true
                      } else {
                        arr[index].value = false
                      }
                      setStates({ ...states, roles: arr })
                    }}
                  />
                }
                label={i?.role_name}
              />
            })}
          </FormGroup>
        </Grid>
        <Grid item xs={4}>
          <FormGroup>{
            roles?.slice(4, 8)?.map(i => {
              return <FormControlLabel
                key={i?.role_id}
                control={
                  <Checkbox
                    color="primary"
                    checked={i?.value}
                    onChange={(e) => {
                      let arr = [...roles];
                      let index = arr.findIndex(k => k.role_id == i.role_id);
                      if (e.target.checked) {
                        arr[index].value = true
                      } else {
                        arr[index].value = false
                      }
                      setStates({ ...states, roles: arr })
                    }}
                  />
                }
                label={i?.role_name}
              />
            })}
          </FormGroup>
        </Grid>
        <Grid item xs={4}>
          <FormGroup>{
            roles?.slice(8,)?.map(i => {
              return <FormControlLabel
                key={i?.role_id}
                control={
                  <Checkbox
                    color="primary"
                    checked={i?.value}
                    onChange={(e) => {
                      let arr = [...roles];
                      let index = arr.findIndex(k => k.role_id == i.role_id);
                      if (e.target.checked) {
                        arr[index].value = true
                      } else {
                        arr[index].value = false
                      }
                      setStates({ ...states, roles: arr })
                    }}
                  />
                }
                label={i?.role_name}
              />
            })}
          </FormGroup>
        </Grid>
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          <Button
            className={classes.submitBtn}
            onClick={() => {
              setStates({ loading: true });
              handleCreateScreen();
            }}
            disabled={loading}
          >
            {'Submit'}
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
